import { gql } from '@apollo/client';

export const MITARBEITER_BY_STANDORT_IDS = gql(`
  query rotationsplan_mitarbeiterByStandortIds($standortIds: [String!]!) {
   mitarbeiter_mitarbeiterByStandortIds(standortIds: $standortIds){
    arbeitnehmerTyp
    id
    nachname
    vorname
   }
  }
`);
